import BaseView from '../../components/CRUDView/CRUDView';
import moment from 'moment';
import React from 'react';
import {Col, FormGroup, InputGroup, InputGroupAddon, Row} from 'reactstrap';
import Utils, {exportFilteredCSV} from '../../common/Utils';
import {
    FarmersEndpoints,
    FBOEndpoints,
    TractorOperatorEndpoint,
    TractorOwnerEndpoints,
    TractorRequestEndpoints,
    TractorsEndpoints,
    USSDEndpoints
} from '../../common/ProxyEndpoints';
import {PayStatus, Permissions, RequestPaymentStatus, RequestStatus, TransactionStatus} from "../../common/Constants";
import TractorRequestBuilder from "../../components/TractorRequestBuilder/TractorRequestBuilder";
import './Requests.css';
import Icon from 'react-icons-kit';
import {ic_colorize} from 'react-icons-kit/md/ic_colorize';
import {renderStatus as StatusRender, TimeRangeInfo, TimeRangeSelectionDialog} from './RequestCommon';
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import _ from 'lodash';
import {Async as AsyncSelect, components} from "react-select";
import Button from "reactstrap/es/Button";
import TwoLineItemRender from "../../components/Elements/TwoLineItemRender";
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css';
import RequestStatisticsDialog from "./RequestStatisticsDialog";
import {CustomFilterFrame} from "../../components/CRUDView";
import {ComparisonOperators, ComparisonSelect} from "../../components/CRUDView/Components/ComparisonSelect";
import ClearButton from "../../components/CRUDView/Components/ClearButton";
import RequestMessaging from "./RequestMessaging";
import {css} from 'glamor';
import classnames from 'classnames';
import {getStatusFiltersForRole, RequestStatusFilter} from "./RequestStatusConfiguration";
import TTLProxy from "../../common/TTLAsyncProxy";
import EventListener from "../../common/EventListener";
import CurrencyLabel from "../../components/CurrencyLabel/CurrencyLabel";
import {broadcastEvent} from "../../common/Events/EventSource";
import EventActions from "../../common/Events/Actions";
import {formatServiceQuantity, getQuantityKey} from "../../common/QuantityHelper";

//  Define properties which are searchable
const SearchProps = [
    'id' ,
    'order_id' ,
    'name' ,
    'phone' ,
    'location' ,
    'service.name',
    getQuantityKey({ acre: 'acres' , hectare: 'hectares' })
];

//  The interval between updates
const UPDATE_CHECK_INTERVAL = 5200;

const CacheDependency = [
    'dashboard',
    'tractor_operators',
    'tractors',
    'tractor_owners'
];

const RequestStyles = {
   [RequestStatus.Completed]: 'completed-request-row',
   [RequestStatus.Assigned]: 'assigned-request-row',
   [RequestStatus.Cancelled]: 'cancelled-request-row',
   [RequestStatus.Unassigned]: 'unassigned-request-row'
};

const bookedRequestStyle = css({
    borderLeft: '#b9b9b9 solid 6px'
});

const isPaidRequest = (request) => {

    switch (request.payment_status.status){
        case PayStatus.RefundFail:
        case PayStatus.PaidFully:
        case PayStatus.PaidPartially:
        case PayStatus.Refunded:
        case PayStatus.RefundPartial:
            return true;
        default:
            return false;
    }
};


class TractorRequest extends BaseView {

    constructor(props) {
        super(props,'tractor_requests');
        this.onRequestUpdate = this.onRequestUpdate.bind(this);
    }

    onRestoreSessionState(session) {

        return {
            toggle_colorize: session.getState('toggle_colorize',false)
        };

    }

    onRequestUpdate(id){

        if(typeof id === "number"){
            this.updateItemSingle(id);
        }
        else{
            return this.refresh();
        }

    }

    componentWillMount() {

        //  init view
        this.initView();

        //  load state
        this.loadState();
    }

    fetchUSSDServices(){

        const options = USSDEndpoints.getUSSDServices();
        return this.execReq(options,{
            include: [ "pricing" ]
        }).then(response => {
            return response.getPayload();
        });

    }

    loadState(){

        return this.fetchUSSDServices().then(services => {

            this.setState({
                ussdServices : services
            });

        });

    }

    onExecuteRequest(url,params,{ filters }){

        let order = params.sort || (params.sort = []);
        const qs = params.query || (params.query = {});
        const {
            timeFrame,
            timeRangeStart,
            timeRangeEnd,
            requestType,
            status
        } = filters;

        if(order.length === 0) {

            // sort by date created in descending order
            order.push('-date_created');
        }


        if(!_.isNil(status)){

            const frame = RequestStatusFilter.find(x => x.value === status);
            if(frame && _.isFunction(frame.onApply)){
                frame.onApply(params);
            }

        }


        if(!_.isNil(requestType)){
            qs.request_type = requestType;
        }

        if(timeFrame){

            qs.request_filter_time_range = timeFrame;

            if(timeRangeStart) {
                qs.request_range_from = timeRangeStart.toJSON();
            }

            if(timeRangeEnd)
                qs.request_range_to = timeRangeEnd.toJSON();
        }

    }

    beginShowDetails(request){
        broadcastEvent(EventActions.ActiveTractorRequestHandler,request.id);
    }

    /**
     * Override data persistence params
     */
    getPersistData(){

        return {
            toggle_colorize: this.state.toggle_colorize
        };

    }

    toggleColorize(){
        this.setStateSafe({ toggle_colorize: !this.state.toggle_colorize } , () => this.persistSession());
    }

    /**
     * Sets the time range to display
     */
    setTimeRangeDisplay(opts){

        //
        const _update = {
            timeFrame: opts.range,
            timeRangeStart: opts.start ? opts.start.toJSON() : null,
            timeRangeEnd: opts.end ? opts.end.toJSON() : null
        };

        //
        this.setQueryFiltersRaw(filters => ({ ...filters, ..._update }));
    }

    /**
     * Clears the time range display info
     */
    clearTimeRangeDisplay(){
        this.setStateSafe({ timeRangeInfo: null }, () => this.refresh());
    }

    togglePaidOnly(){

        this.setQueryFiltersRaw(({ paidRequestOnly , ...filters }) => ({
            ...filters,
            paidRequestOnly: !paidRequestOnly
        }));

    }

    getCustomFilterState(filters) {

        const getSelectOption = (entity,queryKey,filterKey) => {
            const _key = filterKey || `${entity}.id`;
            const _name = filters[queryKey || `${entity}Name`];
            return filters[_key] ? { label: _name , value: filters[_key]  , instance: { id : filters[_key] , name: _name } } : null ;
        };

        return {
            orderId: filters.orderId || '',
            location: filters.location || '',
            quantity: filters.quantity || '',
            rating: filters.rating || '',
            quantityOperator: filters.quantityOperator || '=',
            cost: filters.cost || '',
            costOperator: filters.costOperator || '=',
            tractor: getSelectOption('tractor'),
            name: filters.name || '',
            phone: filters.phone || '',
            fbo: getSelectOption('fbo'),
            farmer: getSelectOption('farmer'),
            commission: filters.commission || '',
            commissionOperator: filters.commissionOperator || '=',
            payout: filters.payout || '',
            payoutOperator: filters.payoutOperator || '=',
            operator: filters.operator || '',
            owner: getSelectOption(undefined,'tractorOwnerName','tractor.owner_id'),
            tractorOperator: getSelectOption('tractor_operator','tractorOperatorName'),
        }
    }

    initView(){

        const me = this;

        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No tractor requests available yet!',

            //  The class icon for the card header
            pageIcon: 'icon-docs',

            //  The title for the content frame
            pageTitle: 'Tractor Requests',

            //  The total number of items per page
            maxItemsPerPage: 10,

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create:{
                    enabled: false,
                },

                //  delete action options
                edit:{
                    enabled : false,
                },

                //  delete action options
                delete: {
                    enabled: true,
                    disallowMany: true,
                    successDeleteMsg: 'Deleted tractor request successfully!',
                    failDeleteMsg: null, // Use response error
                    text: 'Delete Request',
                    isAllowed: (item) => {
                        return me.getProxy().isSuperUser() && item.status == RequestStatus.Unassigned && !(!!item.transactions.find(x => x.status == TransactionStatus.Succeeded));
                    },
                    confirmTitle: 'Confirm Delete Tractor Request',
                    confirmMessage: 'Are you really sure you want to delete the tractor request?',
                }

            },

            queryActions: {

                //  Sets the endpoint url
                endpoint: TractorRequestEndpoints.getUrl(),
            },

            filters: [
                {
                    key: 'orderId',
                    filterKey: 'order_id',  // http request filter query key
                    operator: '[]',
                    query: "order_id",
                    apply: true
                },
                {
                    key: 'phone',
                    operator: '[]',
                    query: 'request_phone',
                    apply: true // indicates this filter should be applied to real query
                },
                {
                    key: 'name',
                    operator: '[]',
                    query: 'request_farmer_name',
                    apply: true // indicates this filter should be applied to real query
                },
                {
                    key: 'cost',
                    query: 'request_cost',
                    operator: filters => filters.costOperator || "=",
                    apply: true,
                    fromQuery: value => isFinite(value) ? Number(value) : undefined
                },
                {
                    key: 'costOperator',
                    query: 'cost_op',
                    fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
                },
                {
                    key: 'quantityOperator',
                    query: 'quantity_op',
                    fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
                },
                {
                    key: 'commissionOperator',
                    query: 'commission_op',
                    fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
                },
                {
                    key: 'payoutOperator',
                    query: 'payout_op',
                    fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
                },
                {
                    key: 'tractor.id',
                    query: 'tractor_id',
                    apply: true
                },
                {
                    key: 'tractorName',
                    query: '_tractor_select_name'
                },
                {
                    key: 'operator',
                    operator: '[]',
                    query: 'network_operator',
                    apply: true
                },
                {
                    key: 'tractor_operator.id',
                    query: "tractor_operator",
                    apply: true
                },
                {
                    key: "tractorOperatorName",
                    query: "_operator_select_name"
                },
                {
                    key: 'location',
                    operator: '[]',
                    query: 'request_location',
                    apply: true
                },
                {
                    key: 'service.id',
                    name: "Service",
                    query: 'request_service_type',
                    apply: true,
                    renderValue: value => {

                        const services = me.state.ussdServices;
                        if(Array.isArray(services) && services.length > 0){
                            let svc = services.find(x => x.id == value);
                            return svc ? svc.name : undefined;
                        }
                    }
                },
                {
                    key: 'tractor.owner_id',
                    query: "owner_id",
                    apply: true
                },
                {
                    key: 'tractorOwnerName',
                    query: "_owner_select_name"
                },
                {
                    key: "requestType",
                    query: "request_type",
                    name: "Request Type",
                    fromQuery: value => {

                        switch ((value || "").toLowerCase()) {
                            case "hiring":
                            case "booking":
                                return value.toLowerCase();
                        }

                    },
                    renderValue: value => {

                        switch (value) {
                            case "hiring":
                                return "Hiring";
                            case "booking":
                                return "Booking";
                        }
                    }
                },
                {
                    key: 'status',
                    name: "Status",
                    query: 'request_status',
                    fromQuery: value => {

                        const filters = getStatusFiltersForRole(TTLProxy.getInstance().getUserRole());
                        let _val = (value || "").toLowerCase();
                        let frame = _val ? filters.find(x => x.value === _val) : null;
                        if(frame){
                            return frame.value;
                        }

                    },
                    renderValue: value => {

                        const frame = RequestStatusFilter.find(x => x.value === value);
                        if(frame){
                            return frame.text;
                        }

                    }
                },
                {
                    key: "rating",
                    filterKey: "operator_rating",
                    query: "operator_rating",
                    apply: true,
                    fromQuery: value => value && isFinite(value) ? Number(value) : undefined
                },
                {
                    key: 'quantity',
                    filterKey: getQuantityKey({ acre: 'acres', hectare: 'hectares' }),
                    query: 'request_quantity',
                    operator: filters => filters.quantityOperator || "=",
                    apply: true
                },
                {
                    key: 'commission',
                    query: 'commission',
                    operator: filters => filters.commissionOperator || "=",
                    apply: true,
                    fromQuery: value => isFinite(value) ? Number(value) : undefined
                },
                {
                    key: 'payout',
                    query: 'payout',
                    operator: filters => filters.payoutOperator || "=",
                    apply: true,
                    fromQuery: value => isFinite(value) ? Number(value) : undefined
                },
                {
                    key: 'farmer.id',
                    query: 'farmer_id',
                    apply: true
                },
                {
                    key: 'farmerName',
                    query: "_farmer_select_name"
                },
                {
                    key: 'fbo.id',
                    query: 'fbo_id',
                    apply: true
                },
                {
                    key: 'fboName',
                    query: '_fbo_select_name'
                },
                {
                    key: "timeFrame",
                    query: "_frame",
                    name: "Date Range",
                    dependencies: [ 'timeRangeStart' , 'timeRangeEnd' ],    //  remove these dependencies when filter chip is deleted
                    fromQuery: value => Object.keys(TimeRangeInfo).includes(value) ? value : undefined,
                    renderValue: (value,filters) => {

                        if(value === "custom"){

                            if(filters.timeRangeStart && filters.timeRangeEnd){
                                return `${moment(filters.timeRangeStart).format('L')} - ${moment(filters.timeRangeEnd).format('L')}`;
                            }

                        }

                        return TimeRangeInfo[value].text;
                    }
                },
                {
                    key: "timeRangeStart",
                    query: "_from",
                    toQuery: value => !_.isNil(value) &&  moment(value).isValid() ? moment(value).toJSON() : undefined,
                    fromQuery: value => {

                        let date = moment(value);
                        if(!_.isNil(value) && date.isValid())
                            return date.toDate();

                        return null;
                    }
                },
                {
                    key: "timeRangeEnd",
                    query: "_to",
                    toQuery: value => !_.isNil(value) && moment(value).isValid() ? moment(value).toJSON() : undefined,
                    fromQuery: value => {

                        let date = moment(value);
                        if(!_.isNil(value) && date.isValid())
                            return date.toDate();

                        return null;
                    }
                }
            ],

            renderCustomFilters: ({ applyFilters , toggle , values , setValue , setValues , resetValues }) => {

                return <CustomFilterFrame toggle={toggle}>

                    <Row className="mb-1">

                        <Col md={3}>

                            <b>Order ID</b>
                            <input name="orderId"
                                   value={values['orderId']}
                                   onChange={evt => {
                                       setValue('orderId',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Request order id"/>

                        </Col>

                        <Col md={3}>

                            <b>Location</b>
                            <input name="location"
                                   value={values['location']}
                                   onChange={evt => {
                                       setValue('location',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Request location"/>


                        </Col>

                        <Col md={3}>

                            <b>Quantity</b>
                            <FormGroup>
                                <InputGroup>


                                    <input name="quantity"
                                           value={values['quantity']}
                                           onChange={evt => {
                                               setValue('quantity',evt.target.value);
                                           }}
                                           type="number"
                                           className="form-control form-input-select"
                                           placeholder="Request quantity"/>

                                    <InputGroupAddon addonType="prepend">
                                        <ComparisonSelect value={values['quantityOperator']} onChange={operator => setValue('quantityOperator',operator)}/>
                                    </InputGroupAddon>

                                </InputGroup>
                            </FormGroup>


                        </Col>

                        <Col md={3}>

                            <b>Cost</b>
                            <FormGroup>
                                <InputGroup>

                                    <input name="cost"
                                           value={values['cost']}
                                           onChange={evt => {
                                               setValue('cost',evt.target.value);
                                           }}
                                           type="number"
                                           className="form-control form-input-select"
                                           placeholder="Request cost"/>

                                    <InputGroupAddon addonType="prepend">
                                        <ComparisonSelect value={values['costOperator']} onChange={operator => setValue('costOperator',operator)}/>
                                    </InputGroupAddon>

                                </InputGroup>
                            </FormGroup>

                        </Col>


                    </Row>

                    <Row className="mb-1">

                        <Col md={3}>

                            <div className="clearfix">
                                <b className="pull-left">Tractor</b>
                                <div className="pull-right">
                                    <ClearButton onClick={() => setValues({
                                        tractor: null,
                                        tractorName: null
                                    })}/>
                                </div>
                            </div>
                            <AsyncSelect  name="tractor"
                                          defaultOptions
                                          cacheOptions
                                          placeholder="Select tractor..."
                                          value={values['tractor']}
                                          onChange={value => {
                                              setValue('tractor',value);
                                          }}
                                          components={{
                                              Option: ({ children , ...props }) => {

                                                  const tractor = props.data.instance;
                                                  return <components.Option {...props}>

                                                      <TwoLineItemRender media={tractor.media}
                                                                        line1Value={`${tractor.name} (${tractor.registration_number})`}
                                                                        line2Prefix="Chassis"
                                                                        line2Value={tractor.chassis}/>

                                                  </components.Option>

                                              }
                                          }}
                                          loadOptions={async (value) => {

                                              try {

                                                  const res = await this.proxy.processRequest(TractorsEndpoints.getUrl(), {
                                                      search: { keyword: value , method: 'inside', fields: ['name','chassis', 'registration_number' ] },
                                                      pagination: { page: 1 , perPage : 5 },
                                                      include: [ 'media' ]
                                                  });

                                                  return res.getPayload().map(t => ({ label: `${t.name} (${t.registration_number})` , value: t.id  , instance: t }));
                                              }
                                              catch (e) {

                                                  // failed to load query

                                              }

                                          }}/>


                        </Col>


                        <Col md={3}>

                            <b>Name</b>
                            <input name="name"
                                   value={values['name']}
                                   onChange={evt => {
                                       setValue('name',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Farmer name"/>

                        </Col>

                        <Col md={3}>
                            <b>Phone No.</b>
                            <input name="phone"
                                   value={values['phone']}
                                   onChange={evt => {
                                       setValue('phone',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Phone no."/>

                        </Col>

                        <Col md={3}>


                            <div className="clearfix">
                                <b className="pull-left">FBO</b>
                                <div className="pull-right">
                                    <ClearButton onClick={() => setValues({
                                        fbo: null,
                                        fboName: null
                                    })}/>
                                </div>
                            </div>
                            <AsyncSelect  name="fbo"
                                          defaultOptions
                                          cacheOptions
                                          placeholder="Select FBO..."
                                          value={values['fbo']}
                                          onChange={value => {
                                              setValue('fbo',value);
                                          }}
                                          components={{
                                              Option: ({ children , ...props }) => {

                                                  const fbo = props.data.instance;
                                                  return <components.Option {...props}>

                                                      <TwoLineItemRender  media={fbo.media}
                                                                          line1Value={fbo.name}
                                                                          line2Prefix="Phone"
                                                                          line2Value={fbo.phone}/>

                                                  </components.Option>

                                              }
                                          }}
                                          loadOptions={async (value) => {

                                              try {

                                                  const res = await this.proxy.processRequest(FBOEndpoints.getUrl(), {
                                                      search: { keyword: value , method: 'inside', fields: ['name','user.email', 'user.phone' ] },
                                                      pagination: { page: 1 , perPage : 5 },
                                                      include: [ 'media' , 'user' ]
                                                  });

                                                  return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                                              }
                                              catch (e) {

                                                  // failed to load query

                                              }

                                          }}/>


                        </Col>



                    </Row>


                    <Row className="mb-1">

                        <Col md={3}>


                            <div className="clearfix">
                                <b className="pull-left">Farmer</b>
                                <div className="pull-right">
                                    <ClearButton onClick={() => setValues({
                                        farmer: null,
                                        farmerName: null
                                    })}/>
                                </div>
                            </div>
                            <AsyncSelect  name="farmer"
                                          defaultOptions
                                          cacheOptions
                                          placeholder="Select farmer..."
                                          value={values['farmer']}
                                          onChange={value => {
                                              setValue('farmer',value);
                                          }}
                                          components={{
                                              Option: ({ children , ...props }) => {

                                                  const farmer = props.data.instance;
                                                  return <components.Option {...props}>

                                                      <TwoLineItemRender  media={farmer.media}
                                                                            line1Value={farmer.name}
                                                                            line2Prefix="Phone"
                                                                            line2Value={farmer.phone}/>

                                                  </components.Option>

                                              }
                                          }}
                                          loadOptions={async (value) => {

                                              try {

                                                  const res = await this.proxy.processRequest(FarmersEndpoints.getUrl(), {
                                                      search: { keyword: value , method: 'inside', fields: ['name' , 'phone' , 'user.email', 'user.phone' ] },
                                                      pagination: { page: 1 , perPage : 5 },
                                                      include: [ 'media' , 'user' ]
                                                  });

                                                  return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                                              }
                                              catch (e) {

                                                  // failed to load query

                                              }

                                          }}/>


                        </Col>

                        <Col md={3}>

                            <b>Commission</b>

                            <FormGroup>
                                <InputGroup>

                                    <input name="commission"
                                           value={values['commission']}
                                           onChange={evt => {
                                               setValue('commission',evt.target.value);
                                           }}
                                           type="number"
                                           min={0}
                                           className="form-control form-input-select"
                                           placeholder="Commission"/>

                                    <InputGroupAddon addonType="prepend">
                                        <ComparisonSelect value={values['commissionOperator']} onChange={operator => setValue('commissionOperator',operator)}/>
                                    </InputGroupAddon>

                                </InputGroup>
                            </FormGroup>

                        </Col>

                        <Col md={3}>

                            <b>Payout</b>

                            <FormGroup>
                                <InputGroup>

                                    <input name="payout"
                                           value={values['payout']}
                                           onChange={evt => {
                                               setValue('payout',evt.target.value);
                                           }}
                                           type="number"
                                           min={0}
                                           className="form-control form-input-select"
                                           placeholder="Payout amount"/>

                                    <InputGroupAddon addonType="prepend">
                                        <ComparisonSelect value={values['payoutOperator']} onChange={operator => setValue('payoutOperator',operator)}/>
                                    </InputGroupAddon>

                                </InputGroup>
                            </FormGroup>


                        </Col>

                        <Col md={3}>

                            <b>Network Operator</b>
                            <input name="networkOperator"
                                   value={values['operator']}
                                   onChange={evt => {
                                       setValue('operator',evt.target.value);
                                   }}
                                   type="text"
                                   className="form-control form-input-select"
                                   placeholder="Mobile network operator"/>

                        </Col>


                    </Row>

                    <Row className="mb-1">

                        <Col md={3}>

                            <div className="clearfix">
                                <b className="pull-left">Tractor Owner</b>
                                <div className="pull-right">
                                    <ClearButton onClick={() => setValues({
                                        owner: null,
                                        tractorOwnerName: null
                                    })}/>
                                </div>
                            </div>
                            <AsyncSelect  name="owner"
                                          defaultOptions
                                          cacheOptions
                                          placeholder="Select tractor owner..."
                                          value={values['owner']}
                                          onChange={value => {
                                              setValue('owner',value);
                                          }}
                                          components={{
                                              Option: ({ children , ...props }) => {

                                                  const owner = props.data.instance;
                                                  return <components.Option {...props}>

                                                      <TwoLineItemRender  media={owner.media}
                                                                          line1Value={owner.name}
                                                                          line2Prefix="Phone"
                                                                          line2Value={owner.user.phone}/>

                                                  </components.Option>

                                              }
                                          }}
                                          loadOptions={async (value) => {

                                              try {

                                                  const res = await this.proxy.processRequest(TractorOwnerEndpoints.getUrl(), {
                                                      search: { keyword: value , method: 'inside', fields: ['name' , 'user.email', 'user.phone' ] },
                                                      pagination: { page: 1 , perPage : 5 },
                                                      include: [ 'media' , 'user' ]
                                                  });

                                                  return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                                              }
                                              catch (e) {

                                                  // failed to load query

                                              }

                                          }}/>

                        </Col>

                        <Col md={3}>

                            <div className="clearfix">
                                <b className="pull-left">Tractor Operator</b>
                                <div className="pull-right">
                                   <ClearButton onClick={() => setValues({
                                       tractorOperator: null,
                                       tractorOperatorName: null
                                   })}/>
                                </div>
                            </div>

                            <AsyncSelect  name="tractorOperator"
                                          defaultOptions
                                          cacheOptions
                                          placeholder="Select tractor operator..."
                                          value={values['tractorOperator']}
                                          onChange={value => {
                                              setValue('tractorOperator',value);
                                          }}
                                          components={{
                                              Option: ({ children , ...props }) => {

                                                  const operator = props.data.instance;
                                                  return <components.Option {...props}>

                                                      <TwoLineItemRender  media={operator.media}
                                                                          line1Value={operator.name}
                                                                          line2Prefix="Phone"
                                                                          line2Value={operator.phone}/>

                                                  </components.Option>

                                              }
                                          }}
                                          loadOptions={async (value) => {

                                              try {

                                                  const res = await this.proxy.processRequest(TractorOperatorEndpoint.getUrl(), {
                                                      search: { keyword: value , method: 'inside', fields: [ 'name' , 'email', 'phone' ] },
                                                      pagination: { page: 1 , perPage : 5 },
                                                      include: [ 'media']
                                                  });

                                                  return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                                              }
                                              catch (e) {

                                                  // failed to load query

                                              }

                                          }}/>
                        </Col>


                        <Col md={3}>
                            <b>Operator Rating</b>
                            <select name="rating"
                                   value={values['rating']}
                                   onChange={evt => {
                                       setValue('rating',evt.target.value);
                                   }}
                                   className="form-control form-input-select"
                                   placeholder="Phone no.">
                                <option value="">None</option>
                                <option value="1">1 - Extremely Poor</option>
                                <option value="2">2 - Poor</option>
                                <option value="3">3 - Fair</option>
                                <option value="4">4 - Good</option>
                                <option value="5">5 - Very Good</option>
                            </select>

                        </Col>

                    </Row>

                    <hr/>

                    <div className="clearfix">

                        <div className="pull-left">
                            <Button onClick={() => resetValues() }><i className="fa fa-refresh"/> Reset Filters</Button>
                        </div>

                        <div className="pull-right">
                            <Button color="green" style={{ borderRadius: 4 }} onClick={() => {

                                let _targetFilter = { };
                                Object.keys(values).forEach(k => {

                                    let _v = values[k];
                                    let _initialValue = _v;

                                    switch (k) {
                                        case "farmer":
                                            k = "farmer.id";
                                            _v = !_.isNil(_v) ? _v.instance.id : null;
                                            _targetFilter['farmerName'] = _v ? _initialValue.instance.name : undefined;
                                            break;
                                        case "fbo":
                                            k = "fbo.id";
                                            _v = !_.isNil(_v) ? _v.instance.id : null;
                                            _targetFilter['fboName'] = _v ? _initialValue.instance.name : undefined;
                                            break;
                                        case "tractor":
                                            k = "tractor.id";
                                            _v = !_.isNil(_v) ? _v.instance.id : null;
                                            _targetFilter['tractorName'] = _v ? _initialValue.instance.name : undefined;
                                            break;
                                        case "owner":
                                            k = "tractor.owner_id";
                                            _v = !_.isNil(_v) ? _v.instance.id : null;
                                            _targetFilter['tractorOwnerName'] = _v ? _initialValue.instance.name : undefined;
                                            break;
                                        case "tractorOperator":
                                            k = "tractor_operator.id";
                                            _v = !_.isNil(_v) ? _v.instance.id : null;
                                            _targetFilter['tractorOperatorName'] = _v ? _initialValue.instance.name : undefined;
                                            break;
                                        case "quantity":
                                            k = getQuantityKey({ acre: "acres" , hectare: "hectares" });
                                            break;

                                    }

                                    if(!_.isNil(_v) && _v !== ""){
                                        _targetFilter[k] = _v;
                                    }
                                    else{
                                        _targetFilter[k] = undefined;
                                    }

                                });

                                applyFilters(_targetFilter);


                            }}><i className="fa fa-check"/> Apply</Button>
                        </div>
                    </div>

                </CustomFilterFrame>
            },

            search:{

                //
                placeholder: 'Search tractor requests...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The searchable properties
                properties: SearchProps

            },

            hooks:{

                postProcessorHook: (action,response) => {
                    Utils.eraseSession(CacheDependency);
                },

                renderCellActions: (item) => {

                    return [
                        {
                            label: "Show Messages",
                            icon: "fa fa-comment",
                            onClick: () => {
                                return this._requestMessaging.show(item);
                            }
                        },
                        {
                            label: "Replicate",
                            icon: "fa fa-copy",
                            onClick: () => {
                                return this._createRequestDlg.show({ request: item  })
                            }
                        }
                    ];

                }


            },

            //  Inputs used in editing and creating items
            inputs: [],

            //  Defines the features of the view
            features: [ 'search' , 'toolbox'],

            //  Multi-selection
            multiSelection: {

                //  enable multi-selection
                enable : false,

            },

            //  Model properties
            model:{

                //  Thus, every tractor request should have these properties set
                include: [
                    'tractor' ,
                    'tractor_operator' ,
                    'owner' ,
                    'fbo',
                    'farmer',
                    'transactions' ,
                    'service',
                    'binder' ,
                    'payment_status',
                    'payments_issued',
                    'status_cycle',
                    'price_binding'
                ]

            },

            //  Define toolbox actions
            toolBox: [

                //  ACTIONS
                {  text: 'Make Request' , icon : 'fa fa-plus' , invoke: () => me.beginShowCreate() , position: 'right' , permissions: [ Permissions.Requests.Create ] },
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  , invoke: () => me.refresh() , position: 'right' },

                {
                    text : 'Status',
                    icon: 'fa fa-signal',
                    invoke: (index) => {
                        me.updateQuery('status',getStatusFiltersForRole(me.proxy.getUserRole())[index].value)
                    },
                    position: 'right' ,
                    group : 'type-filter' ,
                    items: getStatusFiltersForRole(me.proxy.getUserRole()).map(x => x.text),
                    withPortal: true,
                    portalOptions: {
                        title: 'Select Request Status',
                        itemStyle: {
                            cursor: "pointer"
                        }
                    }
                },

                {  text : 'Service'  , icon : 'fa fa-filter' , invoke: (index) => { me.updateQuery('service.id', me.state.ussdServices[index].id ) }, position: 'right' , group : 'type-filter' ,
                    items: () => me.state.ussdServices ? me.state.ussdServices.map(x => x.name) : undefined,
                    withPortal: true,
                    portalOptions: {
                        title: 'Select a service filter',
                        itemStyle: {
                            cursor: "pointer"
                        }
                    }
                },
                {
                    text: '', icon: 'fa fa-calendar',   items: Object.keys(TimeRangeInfo).map(x => TimeRangeInfo[x].label), position: 'left' , style: { marginRight: 10 } , invoke: index => {

                        let timeFrame = Object.keys(TimeRangeInfo)[index];
                        if (timeFrame === "custom") {

                            const filters = this.getQueryFilters();

                            //  show dialog for selecting time range
                            this._timeRangeSelectionDlg.show({
                                start: filters.timeRangeStart,
                                end: filters.timeRangeEnd
                            });

                            //  prevent selection of item
                            return false;

                        } else {

                            this.setTimeRangeDisplay({
                                range: timeFrame
                            });

                        }

                    }

                },
                {
                    text: null , icon: <Icon icon={ic_colorize}/> , invoke: () => me.toggleColorize() , className: () => me.state.toggle_colorize ? 'toolbox-btn-active' : ''
                },
                {
                    text: "Request Type",
                    invoke: (index) => {

                        switch (index) {
                            case 0:
                                me.updateQuery('requestType','hiring');
                                break;
                            case 1:
                                me.updateQuery('requestType','booking');
                                break;
                        }

                    },
                    items: [
                        <span><i className="fa fa-money"/> Hiring</span>,
                        <span><i className="fa fa-calendar"/> Booking</span>,
                    ]
                },
                /*{
                    text: "Paid Only" , className: () => me.getQueryFilter('paidRequestOnly',false) ? 'toolbox-btn-active' : '' , icon: "fa fa-money" , invoke: () => me.togglePaidOnly()
                },*/
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                    switch (index){
                        case 0:
                            return exportFilteredCSV(TractorRequestEndpoints.exportCSV(),{ component: me });
                        case 1:

                            const filters = this.getQueryFilters();
                            this._statsDlg.show(me.getQueryParams({  }),(endpoint,params) => {
                                this.onExecuteRequest(endpoint,params,filters);
                            });
                            break;
                        case 2:
                            return  me.toggleCustomFilterVisibility();
                    }

                }, position: 'right' , group : 'more' ,
                    items: () => ([
                        <span><i className="fa fa-file-text"/> Export to CSV</span>,
                        <span><i className="fa fa-pie-chart"/> Compute Statistics</span>,
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                }

                //{ text: "Export" , icon: "fa fa-file", invoke: () => { } , classname: "btn-outline"  , position: "left"},
            ],

            // Describes the columns present in the table
            columns : [
                {key: 'order_id' , label: 'ID' },
                {key: 'name', label: () => me.sortCol('Farmer','name'), mobile: true },
                {key: 'phone', label: () => me.sortCol('Phone','phone') },
                {key: 'location', label: () => me.sortCol('Location','location')},
                {key: 'type' , label: 'Service', cell: (item,key) => item.service.name , mobile: true  },
                {key:  getQuantityKey({ acre: 'acres' , hectare: 'hectares' }) , label: () => me.sortCol('Quantity', getQuantityKey({ acre: 'acres' , hectare: 'hectares' })) , cell: (item,key) => <span>{formatServiceQuantity(item,{ acre: 'acres' , hectare: 'hectares' , service: item.service })}</span> },
                {key: "cost", label: () => me.sortCol("Cost","cost") , format: 'money' },
                {key: 'status' , label: 'Status' , cell : (item,key) => StatusRender(item), mobile: true },
                {key: 'payment_sent', label: <span><i className="fa fa-money"/> Payout</span> , cell: item => <CurrencyLabel currency={item.txn_currency} value={_.sumBy(item.payments_issued.filter(x => x.status === RequestPaymentStatus.Success),x => x.amount)}/> }
            ],

            renderHooks: {

                header : () => {
                    return null;
/*

                    return (<div className="row clearfix" style={{ padding: 2 , backgroundColor: "#f3f3f3", marginBottom: 10 }}>

                        <div className="col-md-4">
                            <div className="callout callout-success">
                                <small className="text-muted">Request Paid</small><br/>
                                <strong className="h4">{0}</strong>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="callout callout-warning">
                                <small className="text-muted">Offline Users</small><br/>
                                <strong className="h4">{0}</strong>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="callout callout-info">
                                <small className="text-muted">Total Users</small><br/>
                                <strong className="h4">{0}</strong>
                            </div>
                        </div>

                    </div>);
*/
                }

            },

            display:{
                rowClass: (item) =>  classnames((me.state.toggle_colorize ? RequestStyles[item.status] : ''),
                    (item.is_booking && !isPaidRequest(item)  ? bookedRequestStyle.toString() : "") ,
                    (isPaidRequest(item) ? "paid-request-row" : "" ))
            },

            //
            detailsDisplay: {
                enabled: true
            },

            //  Processors
            processors: {

                //  create new item
                createItem: (proxy , payload) => {

                    //  show tractor request builder dialog here

                },

                //  on edit item
                onEditItem: (proxy,item, inputs , done ) => {

                },

                //  called to delete many items
                deleteMany: (proxy,items) => {
                    return proxy.processRequest(TractorRequestEndpoints.deleteRequest(items.map((i) => i.id)));
                },

                //  on delete item
                onDeleteItem: ( proxy,item) => {
                    return proxy.processRequest(TractorRequestEndpoints.deleteRequest(item.id));
                }

            }

        });
    }

    beginShowCreate(){
        this._createRequestDlg.show();
    }

    renderExtra() {
        return <EventListener events={'on_request_update'} onEvent={this.onRequestUpdate}/>
    }

    renderDialogs(dialog){

        const timeRangeInfo = this.state.timeRangeInfo || {};

        return (<React.Fragment>

            {super.renderDialogs(dialog)}

            <RequestStatisticsDialog ref={r => this._statsDlg = r}/>

            <TractorRequestBuilder ref={r => this._createRequestDlg = r}
                                   onRequestCreated={request => this.refresh()}/>

            <RequestMessaging ref={r => this._requestMessaging = r}/>

            <TimeRangeSelectionDialog ref={r => this._timeRangeSelectionDlg = r}
                                      from={timeRangeInfo.start}
                                      to={timeRangeInfo.end}
                                      onApply={({ start , end }) => {

                                          this.setTimeRangeDisplay({
                                              range: "custom",
                                              start,
                                              end
                                          });

                                      }}/>

        </React.Fragment>);

    }


}

export default TractorRequest;



// WEBPACK FOOTER //
// ./src/views/Request/Request.js